import { Badge, makeStyles, tokens } from '@fluentui/react-components';
import { useCallback } from 'react';

interface StepByStepProps {
  step: number;
  children?: React.ReactNode | Iterable<React.ReactNode>;
}

interface StepLabelProps {
  isActive: boolean;
  step: string;
  label: string
}

const StepItem = (props: StepLabelProps) => {
	const styles = useStyles();
	const { isActive, step, label } = props;

	return (
		<span className={styles.itemRoot}>
			<Badge
				size="extra-large"
				color={isActive ? 'brand' : 'subtle'}
				appearance={isActive ? 'filled' : 'tint'}
			>
				{step}
			</Badge>
			<span className={styles.itemLabel}>
				{label}
			</span>
		</span>
	);
};

export function StepByStep(props: StepByStepProps) {
	const styles = useStyles();
	const { step } = props;

	const isActive = useCallback((value: number) => {
		return value === step;
	}, [step]);

	return (
		<div className={styles.root}>
			<div className={styles.stepsHeader}>
				<span className={styles.stepBarSeparator} />
				<div className={styles.stepsContent}>
					<StepItem isActive={isActive(1)} step="1" label="How it works" />
					<StepItem isActive={isActive(2)} step="2" label="Authorization" />
					<StepItem isActive={isActive(3)} step="3" label="You're all set" />
				</div>
			</div>
			<div className={styles.content}>
				{props.children}
			</div>
		</div>
	);
}

export const useStyles = makeStyles({
	root: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '24px 24px',
		boxSizing: 'border-box',
	},
	stepsHeader: {
		width: 'fit-content',
		position: 'relative',
	},
	itemRoot: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: tokens.spacingVerticalS,
	},
	itemLabel: {
		display: 'block',
	},
	stepsContent: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: tokens.spacingVerticalS,
		gap: '64px',
	},
	stepBarSeparator: {
		display: 'block',
		width: '100%',
		height: '1px',
		backgroundColor: tokens.colorSubtleBackgroundSelected,
		top: 'calc(50% - 14px)',
		position: 'absolute',
	},
	content: {
		width: '100%',
		height: '100%',
	}
});